'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seo = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _actions = require('../actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var seo = exports.seo = function seo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actions.PAGE_DATA_RECEIVED:
      var pageType = (0, _lodash2.default)(action.payload, 'page.currentPageType');
      switch (pageType) {
        case 'cardDetails':
        case 'cardDetails_business_explorer':
        case 'corporateCardDetails':
          return (0, _extends3.default)({}, state, (0, _lodash2.default)(action.payload, 'cards[0].seo') || {});
          break;
        default:
          return (0, _extends3.default)({}, state, (0, _lodash2.default)(action.payload, 'page.seo') || {});
      }
    default:
      return state;
  }
};